import { createSignal, Show } from "solid-js"
import { DataTypes, useLocalStore } from "@/context/StateContext"
import Types from "@/types"
import { v4 as uuid } from "uuid"
import LabeledInput from "./LabeledInput"

type Props = {
  onCreate: (id: string) => Promise<void>
  categoryType?: string
  label?: string
  optional?: boolean
}

export default function CreateNameDialog(props: Props) {
  const localStore = useLocalStore()
  const [name, setName] = createSignal('')
  const dialogId = `create-name-${uuid()}`

  const create = async (e: Event) => {
    e.preventDefault()
    if (!props.optional && !name()) return

    const id = uuid()
    if (name()) {
      await localStore.createConnection({
        origin: id,
        type: Types.Name,
        target: name(),
        targetType: DataTypes.String
      })
    }

    if (props.categoryType) {
      await localStore.createConnection({
        origin: id,
        type: Types.Category,
        target: props.categoryType,
        targetType: DataTypes.Reference
      })
    }

    await props.onCreate(id)
    setName('')
    document.getElementById(dialogId)?.hidePopover()
  }

  return (
    <div class="flex flex-col gap-2">
      {/* <label class="text-sm font-medium text-gray-700 dark:text-gray-300">Add new {activeCategoryName() || 'item'}</label>
      <div class="flex flex-row items-center gap-2 w-full">
        <input
          type="text"
          value={newCategoryItemName()}
          onInput={(e: any) => setNewCategoryItemName(e.target.value)}
          class="flex h-9 w-full rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-3 text-sm shadow-sm focus:border-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-100 dark:focus:ring-gray-700"
          placeholder={`Name for new ${activeCategoryName() || 'item'}...`}
        />
        <button
          onClick={async () => {
            const newItemId = uuid()
            if (newCategoryItemName()) {
              await localStore.createConnection({
                origin: newItemId,
                type: Types.Name,
                target: newCategoryItemName(),
                targetType: DataTypes.String
              })
            }
            await localStore.createConnection({
              origin: newItemId,
              type: Types.Category,
              target: activeCategory(),
              targetType: DataTypes.Reference
            })
            setNewCategoryItemName('')
          }}
          class="inline-flex h-9 items-center rounded-md bg-gray-900 dark:bg-gray-700 px-3 text-sm font-medium text-white hover:bg-gray-800 dark:hover:bg-gray-600"
        >
          Add
        </button>
      </div> */}
    </div>
  )
}
